
import { set, sub, formatDistanceToNow } from 'date-fns';
import moment from 'moment';
const initialState = {
  notificationsData: [],
  readTime: '',
};
export default function notificationsReaderStstus(state = initialState, action) {
  switch (action.type) {
    case 'READER_STATUS_ADD_ITEM': {
      const menuItemCopy = state.notificationsData.slice();
      return {
        notificationsData: [{
          "data": action.payload,
          // "date": sub(new Date(), { hours: 0, minutes: 0 }),
          "isUnRead": true
        }].concat(menuItemCopy)
      };
    }
    case 'READER_STATUS_INIT_ITEM': {
      const menuItemCopy = state.notificationsData.slice();
      const notificationsData = []
      const tempData = action.payload
      tempData.forEach((item) => {
        // item.receiveTime -> utc+8
        const time = new Date(`${moment(item.receiveTime)}`)
        const time1 = new Date(`${moment(localStorage.readTime1).add(8,'hours')}`)
        const date = sub(time, { hours: 0, minutes: 0 })
        if(time1 > time){
          notificationsData.push({
            "data": item,
            // "date": sub(time, { hours: 0, minutes: 0 }),
            "isUnRead": false
          })
        }
        else {
          notificationsData.push({
            "data": item,
            // "date": sub(time, { hours: 0, minutes: 0 }),
            "isUnRead": true
          })
        }
      });
      notificationsData.concat(menuItemCopy)
      return { notificationsData };
    }
    case 'READER_STATUS_CLEAN_ITEM': {
      return { notificationsData: [] };
    }
    case "READER_STATUS_SET_USER_READTIME": {
      return {
        ...state,
        readTime: action.payload
      };
    }
    case 'READER_STATUS_isRead': {
      return {
        notificationsData: state.notificationsData.map((notification) => ({
          ...notification,
          isUnRead: false
        }))
      };

    }
    default:
      return state;
  }
};

